'use client';
import { FileAttachmentTray } from '#pplx/frontend/composer-sdk-plugins/file-attachments/indexComponents.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
export function createFileAttachmentsPluginFactory() {
    const plusMenuItems = [
        {
            id: 'add-files',
            render: ({ closeMenu, props }) => props.renderAddFilesMenuItem({ closeMenu }),
        },
    ];
    return createPluginFactory({
        name: 'file-attachments',
        hasContent: (props) => props.hasContent,
        capabilities: [
            {
                kind: 'filePicker',
                configure: (props) => ({
                    accept: props.acceptedFileTypes,
                    disabled: props.disabled,
                    multiple: true,
                    onSelect: (files) => props.onFilesSelected(files, 'picker'),
                }),
            },
            {
                kind: 'fileDrop',
                configure: (props) => ({
                    disabled: props.disabled,
                    onDrop: props.onDropItems,
                    validate: props.validateDropItems,
                }),
                renderOverlay: (props, state) => props.renderDropOverlay(state),
            },
            {
                kind: 'filePaste',
                configure: (props) => ({
                    disabled: props.disabled,
                    onPaste: props.onPaste ?? ((files) => props.onFilesSelected(files, 'paste')),
                    oversizedText: props.oversizedText,
                }),
            },
            {
                kind: 'plusMenu',
                items: async () => plusMenuItems,
            },
            {
                kind: 'slot',
                components: [
                    {
                        slot: 'attachmentTray',
                        component: FileAttachmentTray,
                    },
                ],
            },
        ],
    });
}
//# sourceMappingURL=index.js.map